import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { selectEntities as selectVehicles } from './+state/vehicles/vehicles.interfaces';
import { VehicleQueryParameters } from '@quorum/models/xs-query';
import * as fromVehicles from './+state/vehicles/vehicles.actions';

@Injectable()
export class VehicleStateService {
  constructor(private store: Store<any>) {}
  getVehicle(vehicleId: number) {
    return this.store.pipe(
      select(selectVehicles),
      filter((vehicles: any) => {
        return !this.isEmpty(vehicles);
      }),
      map((vehicles: any) => {
        return vehicles[vehicleId];
      })
    );
  }

  getVehicleFromServer(vehicleId: number) {
    // this.store.dispatch(new fromVehicles.GetVehicleFromServer(vehicleId));
  }

  getVehiclesFromServer(queryParams: VehicleQueryParameters) {
    this.store.dispatch(new fromVehicles.GetVehiclesFromServer(queryParams));
  }

  isEmpty(obj: any) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }
}
